import { render, staticRenderFns } from "./PintuanCreate.vue?vue&type=template&id=1b55f2a1&scoped=true"
import script from "./PintuanCreate.vue?vue&type=script&lang=js"
export * from "./PintuanCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b55f2a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b55f2a1')) {
      api.createRecord('1b55f2a1', component.options)
    } else {
      api.reload('1b55f2a1', component.options)
    }
    module.hot.accept("./PintuanCreate.vue?vue&type=template&id=1b55f2a1&scoped=true", function () {
      api.rerender('1b55f2a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/goodsManage/pintuanSpu/PintuanCreate.vue"
export default component.exports